import { Component, OnInit } from '@angular/core';
import { DataStoreService, TitleService } from '@kservice';

@Component({
  selector: 'kp-screen-deletion-requested',
  templateUrl: './screen-deletion-requested.component.html',
  styleUrls: ['./screen-deletion-requested.component.scss'],
})
export class ScreenDeletionRequestedComponent implements OnInit {
  private _title = 'Account Deletion Requested';

  constructor(public dataStoreService: DataStoreService, private titleService: TitleService) {}

  ngOnInit() {
    this.titleService.set(this._title);
  }
}
